<template>
  <CommonCTABlock v-if="ctaBlockPage.includes(route.name)"></CommonCTABlock>
</template>

<script setup>
const route = useRoute();
const ctaBlockPage = ["awards"];
</script>
